import { render, staticRenderFns } from "./tip-box.vue?vue&type=template&id=762d1738&scoped=true"
import script from "./tip-box.vue?vue&type=script&lang=js"
export * from "./tip-box.vue?vue&type=script&lang=js"
import style0 from "./tip-box.vue?vue&type=style&index=0&id=762d1738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762d1738",
  null
  
)

export default component.exports